import { BaseModel } from "../Generics/BaseModel"

export class AddtionalStockEntity extends BaseModel {
  genericFoodEntityId: number

  additionalEntityId: number

  hasStockControl: boolean

  stockQuantity: number

  constructor(data: Partial<AddtionalStockEntity> = {}) {
    super()

    this.genericFoodEntityId = data.genericFoodEntityId ?? -1

    this.additionalEntityId = data.additionalEntityId ?? -1

    this.hasStockControl = data.hasStockControl ?? false

    this.stockQuantity = data.stockQuantity ?? 0
  }

  get isOutOfStock(): boolean {
    return this.hasStockControl && this.stockQuantity <= 0
  }
}
